import { getField, updateField } from 'vuex-map-fields';
import AdminService from '@/services/AdminService';

const getDefaultState = function () {
    return {
        id: null,
        name: null,
        displaySeperateLawText: null,
        exercises: null,
        videos: null,
        isAcademy: null,
        isActive: null,
        laws: null,
    };
};

/* eslint no-shadow: ["error", { "allow": ["state"] }] */
const state = getDefaultState();

const getters = {
    getField,
    form: (state) => ({
        id: state.id,
        name: state.name,
        displaySeperateLawText: state.displaySeperateLawText,
        exercises: state.exercises,
        videos: state.videos,
        isAcademy: state.isAcademy,
        isActive: state.isActive,
        laws: state.laws,
    }),
};

const mutations = {
    setLawCollection(state, value) {
        if (value) {
            // value.Transfers.forEach((status) => {
            //     status.Events.sort((a, b) => new Date(a.Date) - new Date(b.Date));
            // });
            Object.assign(state, value);
        } else {
            Object.assign(state, getDefaultState());
        }
    },

    storeReportDetails(state, data) {
        Object.assign(state, data);
    },
    updateField,
};

const actions = {
    async loadLawCollection({ commit }, data) {
        const res = await AdminService.getAdminLawCollection(data.id);
        commit('setLawCollection', res.data);
        return res.data;
    },
    async loadLawCollectionAdmin({ commit }, data) {
        const res = await AdminService.getReportAdmin(data.id);
        commit('setLawCollection', res.data);
        return res.data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
